<script>
import Vue from 'vue'
var bus = new Vue({
  name: 'AppBus'
})
window.appBus = bus
export default bus
</script>
